import { LOAD_STATE } from '@/shared/types'
import type { MediaNewsRankResponse } from '@/server/types'
import { getMediaNewsRankApi } from '@/server'

export function logicMediaNewsRank() {
  const state = ref(LOAD_STATE.INIT)
  const data = ref<MediaNewsRankResponse[]>([])

  async function getRankData(columnId: number) {
    const res = await useLoadState({
      state,
      key: `媒体报道_${columnId}`,
      onlyClient: true,
      fn: () => getMediaNewsRankApi(columnId),
    })

    if (res && res.data)
      data.value = res.data.slice(0, 10)
  }

  return {
    state,
    data,
    getRankData,
  }
}
